import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll position to the top on every route change,
 * so navigating from a footer link never lands the user mid-page.
 * If a navigation explicitly carries a `scrollTo` target, we let the
 * destination page handle the smooth scroll instead.
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null | undefined;
    if (state && state.scrollTo) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.state]);

  return null;
}